import Open from './open.png';
import Impressions from './impressions.png';
import View from './view.png';
import Sent from './sent.png';
import None from './none.png';
import Click from './click.png';
import Completed from './completed.png';
import VideoCall from './video-call.png';
import PhoneCall from './phonecall.png'
import F2F from './f2f.png';
import Pageview from './pageview.png';
import Video from './video.png';
import EmailBounce from './emailBounce.png'
 
export const engagementActionIcon = {
    'open': Open,
    'opened': Open,
    'impressions': Impressions,
    'impression': Impressions,
    'view': View,
    'sent': Sent,
    'none': None,
    'click': Click,
    'clicks': Click,
    'clicked': Click,
    'delivered': Sent,
    'completed': Completed,
    'video call' : VideoCall,
    'phone call' : PhoneCall,
    'f2f' : F2F,
    'dismissed': None,
    'actioned': Completed,
    'pageview' : Pageview,
    'video' : Video,
    'page view' : Pageview,
    'bounce' : EmailBounce
}